import { streamAgentMessage } from "./agentStreamService";
import {
  createAgentRunnerSession,
  pingAgentRunnerSession,
} from "./agentRunnerClient";
import type { AgentSseHandlers } from "../../utils/parseAgentSseStream";
import type { AgentChatResponse } from "../../types/agentChat";
import { agentApiBase } from "../../utils/agentApiBase";

const AGENT_ID = "architect-intake";

export async function createArchitectIntakeSession(): Promise<string> {
  return createAgentRunnerSession(AGENT_ID);
}

export async function pingArchitectIntakeSession(sessionId: string): Promise<boolean> {
  return pingAgentRunnerSession(AGENT_ID, sessionId);
}

export async function streamArchitectIntakeMessage(
  sessionId: string,
  message: string,
  handlers: AgentSseHandlers = {},
): Promise<AgentChatResponse> {
  const base = await agentApiBase(AGENT_ID);
  return streamAgentMessage(
    base,
    sessionId,
    message,
    handlers,
    "Intake assistant error",
  );
}
